import { FilterTypes } from '../../../models/filterEnums.model';
import { FilterCriteria } from '../shared/filter-criteria.model';

export class KeywordsFilter extends FilterCriteria {
  public override title = 'Keywords';
  public override type: FilterTypes = FilterTypes.Keywords;

  fullOverview = false;
  tradeDescription = false;
  nativeLanguage = false;
  booleanSearch: string = null;

  public override validate(): boolean {
    return true;
  }

  public override toString(): string {
    const extractFrom: string[] = [];

    if (this.fullOverview) extractFrom.push('Full Overview');
    if (this.tradeDescription) extractFrom.push('Trade Description');
    if (this.nativeLanguage) extractFrom.push('Native Language');

    return extractFrom.join(', ') + ': ' + this.booleanSearch;
  }
}
